import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface OnboardingStep {
  id: string;
  label: string;
  completed: boolean;
  order: number;
  action_url: string | null;
}

export interface OnboardingData {
  steps: OnboardingStep[];
  completed_count: number;
  total: number;
  all_complete: boolean;
}

export function useOnboarding() {
  const query = useQuery({
    queryKey: queryKeys.onboarding.status(),
    queryFn: () => api<OnboardingData>("/api/v2/onboarding"),
  });

  return {
    onboarding: query.data ?? null,
    loading: query.isLoading,
    error: query.error ? "Failed to load onboarding" : "",
  };
}
